export const data = [
  {
    id: 2,
    propertyName: 2,
    orderBy: 'Symbol',
    order: 'asc',
    align: 'center',
    title: 'Ticker',
  },
  {
    id: 3,
    propertyName: 3,
    orderBy: 'spot',
    order: 'asc',
    align: 'right',
    title: 'Price',
  },
  {
    id: 4,
    propertyName: 4,
    orderBy: 'spotchg',
    order: 'asc',
    align: 'right',
    title: 'Chg',
  },
  {
    id: 5,
    propertyName: 5,
    orderBy: 'spotchgpct',
    order: 'asc',
    align: 'right',
    title: 'Chg%',
  },
  {
    id: 6,
    propertyName: 6,
    orderBy: 'mkt',
    order: 'asc',
    align: 'right',
    title: 'Mkt Cap',
  },
  {
    id: 7,
    propertyName: 7,
    orderBy: 'earningss',
    order: 'asc',
    align: 'right',
    title: 'Earnings',
  },
  {
    id: 8,
    propertyName: 8,
    orderBy: 'div',
    order: 'asc',
    align: 'right',
    title: 'Div',
  },
  {
    id: 9,
    propertyName: 9,
    orderBy: 'volume',
    order: 'asc',
    align: 'right',
    title: 'Volume',
  },
  {
    id: 10,
    propertyName: 10,
    orderBy: 'calls',
    order: 'asc',
    align: 'right',
    title: 'Calls',
  },
  {
    id: 11,
    propertyName: 11,
    orderBy: 'puts',
    order: 'asc',
    align: 'right',
    title: 'Puts',
  },
  {
    id: 12,
    propertyName: 12,
    orderBy: 'RV',
    order: 'asc',
    align: 'right',
    title: 'RV',
  },
  {
    id: 13,
    propertyName: 13,
    orderBy: 'IV',
    order: 'asc',
    align: 'right',
    title: 'IV',
  },
  {
    id: 14,
    propertyName: 14,
    orderBy: 'atmchg',
    order: 'asc',
    align: 'right',
    title: 'Chg',
  },
];
export const meta = {
  title: 'Unusual Options Activity - OptionsGeek',
  description:
    'Free Unusual Options Activity scanner shows you the highest volume options of top stocks ranked by implied volatility changes and relative option volume. (edited)',
  canonical: 'https://tools.optionsgeek.com/unusualoptionsactivity',
  keywords:
    'unusual, options, activity, marketing, financial, najarian, stock, volume, track, highest, flow, tracker, scanner',
};



// WEBPACK FOOTER //
// ./src/Pages/UnusualOptionsActivity/components/tables/data.js